/* eslint-disable max-len */
import React from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ErrorBoundary } from '../../../components/common/ErrorBoundary'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { FindSocietyConfirmActivationForm } from '../../../components/find-society/FindSociety/FindSocietyConfirmActivationForm'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'
import { societyQueries } from '../../../api/societies'

export const FindSocietyViewConfirmActivationView = (): React.ReactNode => {
  useDocumentTitle(
    reverseDocumentTitle('find-society:confirm-activation-detail')
  )
  const { translate } = useAppTranslation()
  const { id } = useParams()
  const { data: society } = useQuery(societyQueries.getSociety(id))

  return (
    <ErrorBoundary>
      <div className="h-full w-full overflow-y-auto p-6">
        <>
          <p style={theme.textVariants.h2}>
            {translate('findSocietyConfirmActivationView.title')}
          </p>
          <p className="mt-2" style={theme.textVariants.base}>
            {translate('findSocietyConfirmActivationView.subtitle')}
          </p>
          {society && <FindSocietyConfirmActivationForm society={society} />}
        </>
      </div>
    </ErrorBoundary>
  )
}
